import type { Page } from '../../components/organisms/Tabs/types'

export const SUBHEADER_TAB_CONTEXT_INITIAL_VALUES = {
  counts: {},
  pages: [] as Page[],
  selectedTabName: '',
  setCounts: () => {},
  setSelectedTabName: () => {},
}
